export const formatCompanyAddress = (address: {
  company_outlet_name?: string | null
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  region?: string | null;
  postalCode?: string | null;
}) => {
  return [
    address.company_outlet_name,
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.region,
    address.country,
    address.postalCode,
  ]
    .map((value) => value?.trim())
    .filter((value) => value && value.length > 0)
    .join(", ");
};
